import React from 'react';
import * as orderActions from '../actions/orderActions';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {GridList, GridListTile, GridListTileBar, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions,  Button, TextField} from '@material-ui/core';
import { v4 } from 'uuid';

const importAll = (r) => {
    let images = {};
    r.keys().map((item, index) => {
        images[item.replace('./', '')] = r(item);
    });
    return images;
}
const images = importAll(require.context('../assets/img', false, /\.(png|jpe?g|svg)$/));

const styles = {
    root: {
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-around',
    },
    gridList: {
        width: '100%',
        height: '100%',
        overflowY: 'auto',
        marginTop: '5px',
        marginLeft: '5px'
    }
};

const tiles = [
    {id: 0, title: 'Secador', img: images['hair-dryer.png']},
    {id: 1, title: 'Aspiradora', img: images['vacuum-cleaner.png']},
    {id: 2, title: 'Microondas', img: images['microwave-oven.png']},
    {id: 3, title: 'Televisión', img: images['television.png']},
    {id: 4, title: 'Plancha', img: images['iron.png']},
    {id: 5, title: 'Horno', img: images['oven.png']},
    {id: 6, title: 'Lavadora', img: images['washing-machine.png']},
    {id: 7, title: 'Nevera', img: images['fridge.png']},
    {id: 8, title: 'Batidora', img: images['blender.png']},
    {id: 9, title: 'Cafetera', img: images['coffee-maker.png']},
    {id: 10, title: 'Tostadora', img: images['toaster.png']},
    {id: 11, title: 'Otro', img: images['manual.png']}
];

const ProductsGrid = ({order, ...props}) => {
    const [open, setOpen] = React.useState(false);
    const [product, setProduct] = React.useState({});

    const cleanProduct = () => {
        setProduct({});
    };

    const setRefProduct = (refProduct) => {
        let prod = {...refProduct};
        prod.model = (prod.model) ? prod.model : "";
        prod.price = (prod.price) ? prod.price : "";
        prod.quantity = (prod.quantity) ? prod.quantity : 1;
        setProduct(prod);
    };

    const setProductTitle = (event) => {
        let title = event.target.value;
        let prod = {...product};
        prod.title = title;
        setProduct(prod);
    };

    const setProductModel = (event) => {
        let model = event.target.value;
        let prod = {...product};
        prod.model = model;
        setProduct(prod);
    };

    const setProductPrice = (event) => {
        let price = event.target.value;
        let prod = {...product};
        prod.price = price;
        setProduct(prod);
    };

    const setProductQuantity = (event) => {
        let quantity = event.target.value;
        let prod = {...product};
        prod.quantity = quantity;
        setProduct(prod);
    };

    const checkIsDisabledTitleProduct = () =>{
        return (product.id !== 11);
    };

    const cleanFormObject = (refProducto) => {
        if(refProducto.id == 11) refProducto.title = 'Otro';
        for (var key in refProducto) {
            if(key !== 'id' && key !== 'img' && key !== 'title'){
                delete refProducto[key];
            }
        }
        return refProducto;
    };

    const calculateTotal = (lines) =>{
        let total = 0;
        lines.forEach((line, index) => {
            let price = parseFloat(line.price);
            let quantity = parseFloat(line.quantity);
            total = total + (price * quantity);
        });
        total = total.toFixed(2);
        return total;
    };

    const handleOpen = (refProducto) => {
        refProducto = cleanFormObject(refProducto);
        setOpen(true);
        setRefProduct(refProducto);
    };

    const handleCancel = () => {
        setOpen(false);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleAdd = () => {
        const newPrice = (product.price == "") ? 0 : product.price; 
        const newKey = v4();
        const { id, ...productTemplate } = product;
        const addProduct = {...productTemplate};
        addProduct.price = newPrice;
        addProduct.key = newKey;
        let newLines = order.lines;
        newLines.push(addProduct);
        let newTotal = calculateTotal(newLines);
        props.actions.addOrderLine(newLines, newTotal);
        cleanProduct();
        setOpen(false);
    }

    const handleKeyDown = (event) => {
        if(event.keyCode === 13){
            handleAdd();
        }
    }

    return (
        <div style={styles.root}>
            <GridList
                cellHeight={180}
                style={styles.gridList}
                cols={4}
            >
                {tiles.map((tile) => (
                    <GridListTile
                        key={tile.id}
                        style={{textAlign:'center', cursor: 'pointer'}}
                        onClick={() => handleOpen(tile)}
                        className="products-grid-tile"
                    >
                        <img src={tile.img} alt="tile_img"/>
                        <GridListTileBar
                            title={tile.title}
                            style={{
                                maxHeight:'30px'
                            }}
                        />
                    </GridListTile>
                ))}
            </GridList>

            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="form-dialog-title"
                fullWidth={true}
                maxWidth={'xs'}
            >
                <DialogTitle id="form-dialog-title" style={{textAlign: 'center'}}>
                    Añadir producto
                </DialogTitle>
                <DialogContent style={{textAlign: 'center'}}>
                        <TextField
                            id="product_type"
                            label="Tipo de producto"
                            value={product.title}
                            onChange={setProductTitle}
                            disabled={checkIsDisabledTitleProduct()}
                            margin="normal"
                            fullWidth={true}
                        /><br />

                        <TextField
                            autoFocus={true}
                            id="product_model"
                            label="Modelo del producto"
                            value={product.model}
                            onChange={setProductModel}
                            margin="normal"
                            fullWidth={true}
                            onKeyDown={handleKeyDown}
                        /><br />

                        <TextField
                            id="price"
                            label="Precio"
                            value={product.price}
                            onChange={setProductPrice}
                            margin="normal"
                            type="number"
                            fullWidth={true}
                            onKeyDown={handleKeyDown}
                            inputProps={{ 
                                min: "0",
                                step: "0.01" 
                            }}
                        /><br />

                        <TextField
                            id="quantity"
                            label="Cantidad"
                            defaultValue={product.quantity}
                            onChange={setProductQuantity}
                            disabled={true}
                            margin="normal"
                            type="number"
                            fullWidth={true}
                            inputProps={{ 
                                min: "0",
                                step: "1" 
                            }}
                        /><br />
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="primary">
                        Cancelar
                    </Button>
                    <Button onClick={handleAdd} color="primary">
                        Añadir
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(orderActions, dispatch)
    };
}

const mapStateToProps = (state) => ({
    main: state.main,
    order: state.order
});

export default connect(mapStateToProps,mapDispatchToProps)(ProductsGrid);


// WEBPACK FOOTER //
// ./src/components/ProductsGrid.js